import "moment/locale/es";
import "moment/locale/fr";

import AppController from "dbl-components/lib/js/app-controller";

import CvController from "./controllers/cv-controller";

import rootSchema from "./schemas/root-schema.json";
import cv from "./schemas/cv-schema.json";

const props = {
  schema: rootSchema,
  routes: [cv],
  definitions: [],
  api: process.env.REACT_APP_API_URL,
  controllers: {
    CvController
  },
  icons: require('./cv-v1.0/selection.json'),
  lang: "es",
  dictionary: {
    "default": {
      "Perfil": "Profile",
      "La información lo es todo.": "Information is everything.",
      "Enfoque": "My own perspective",
      "Contacto": "Contact",
      "Teléfono": "Cell Phone",
      "Sitio Web": "Web Site",
      "Correo Electrónico": "Email",
      "Portafolio": "Portfolio",
      "=== Ver más ===": "=== Show more ===",
      "Habilidades": "Skills",
      "Experiencia": "Experience",
      "Educación": "Education"
    },
    "en-US": {
      "Perfil": "Profile",
      "La información lo es todo.": "Information is everything.",
      "Enfoque": "My own perspective",
      "Contacto": "Contact",
      "Teléfono": "Cell Phone",
      "Sitio Web": "Web Site",
      "Correo Electrónico": "Email",
      "Portafolio": "Portfolio",
      "=== Ver más ===": "=== Show more ===",
      "Habilidades": "Skills",
      "Experiencia": "Experience",
      "Educación": "Education"
    },
    "en": {
      "Perfil": "Profile",
      "La información lo es todo.": "Information is everything.",
      "Enfoque": "My own perspective",
      "Contacto": "Contact",
      "Teléfono": "Cell Phone",
      "Sitio Web": "Web Site",
      "Correo Electrónico": "Email",
      "Portafolio": "Portfolio",
      "=== Ver más ===": "=== Show more ===",
      "Habilidades": "Skills",
      "Experiencia": "Experience",
      "Educación": "Education"
    },
    "es": {
      "Perfil": "Perfil",
      "La información lo es todo.": "La información lo es todo",
      "Enfoque": "Enfoque",
      "Contacto": "Contacto",
      "Teléfono": "Teléfono",
      "Sitio Web": "Sitio Web",
      "Correo Electrónico": "Correo Electrónico",
      "Portafolio": "Portafolio",
      "=== Ver más ===": "=== Ver más ===",
      "Habilidades": "Habilidades",
      "Experiencia": "Experiencia",
      "Educación": "Educación",
    },
    "es-MX": {
      "Perfil": "Perfil",
      "La información lo es todo.": "La información lo es todo",
      "Enfoque": "Mi propio enfoque",
      "Contacto": "Contacto",
      "Teléfono": "Teléfono",
      "Sitio Web": "Sitio Web",
      "Correo Electrónico": "Correo Electrónico",
      "Portafolio": "Portafolio",
      "=== Ver más ===": "=== Ver más ===",
      "Habilidades": "Habilidades",
      "Experiencia": "Experiencia",
      "Educación": "Educación",
    }
  }
}

const appCtrl = new AppController(props);

appCtrl.set('thisUrl', process.env.REACT_APP_THIS_URL);

export default appCtrl;